import { render } from "./index.vue?vue&type=template&id=1c5860a4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1c5860a4&lang=scss&scoped=true"

import exportComponent from "D:\\project\\websites\\zct_v2_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5860a4"]])

export default __exports__